import './App.css';
import Profile from './Profile';

export default function App() {
  return <Profile />;
}
